module.exports = __webpack_public_path__ + "static/media/6-7.8d424a62.mp3";